/* global require */
import { register } from '../app/index';
import _ from 'underscore';

const components = {
    'article-nav': 'nav',
    'article-list': 'list',
    'article-pagination': 'pagination',
};

_.each(components, (path, tag) => {
    const { default: Component } = require(`./components/${path}`);

    register(tag, Component);
});
